import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat',
  standalone: true
})
export class PhoneFormatPipe implements PipeTransform {
  transform(value: string | number | undefined): string {
    if (!value) return '';

    const num = value.toString().replace(/\D/g, '');

    return num.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
  }
}
